<div class="wrapper">
  <div class="flex-container">
    <div class="message">
      <p>Your invitation has expired</p>
      <p>Please ask your account administrator to send a new invitation in order to join this organisation</p>
      <p>The Land App Team</p>
    </div>
  </div>
</div>
